import { gql } from "apollo-boost";

export const GET_STUDENT_PROFILE = gql`
  query getStudent($id : ID!){
    getStudent (
      id: $id
    ) {
      id
      degree {
        id
        code
        nameLocal
      }
      curriculum {
        id
        code
        nameLocal
        nameEng
      }
      faculty {
        id
        code
        nameLocal
        nameEng
      }
      department {
        id
        code
        nameLocal
        nameEng
      }
      code
      prefix {
        id
        nameLocal
        nameShortLocal
        nameEng
        nameShortEng
      }
      firstNameLocal
      lastNameLocal
      firstNameEng
      lastNameEng
      gender
      telephone
      email
      picturePath
      birthDate
      citizenId
      project{
        id
        nameLocal
        nameEng
      }
      studentStatus {
        id
        nameLocal
        nameEng
      }
      user {
        id
        userLogin
        userGroup{
          id
          code
        }
      }
    }
  }
`;

export const GET_STUDENT_ENROLL = gql`
  query getStudentEnrollsByStudentId($id : ID!){
    getStudentEnrollsByStudentId (
      id: $id
    ) {
      id
      student {
        id
      }
      studentCode
      enrollDate
      totalCredit
      totalDropCredit
      studentEnrollDetails {
        id
        studentEnroll {
          id
          periodCode
        }
        studentUnitTests {
          id
          unitSeq
          isPosttestDone
          pretestMaxScore
          pretestQuestionQty
          pretestScore
          isPretestDone
          posttestMaxScore
          posttestQuestionQty
          posttestScore
          isPosttestDone
        }
        studentUnitLearns {
          id
          studentEnroll {
            id
          }
          studentEnrollDetail {
            id
          }
          courseOutlineUnit {
            id
            seq
          }
          vdoSetUnit {
            id
            totalVdoLength
          }
          studentTopicLearns {
            id
            studentUnitLearn {
              id
              unitSeq
              totalVdoLength
              totalLearnTime
            }
            studentEnrollDetail {
              id
            }
            vdoSetUnit {
              id
              totalVdoLength
            }
            vdoSetTopic {
              id
              no
            }
            vdoLength
            learnTime
            learnPercent
            firstPlayVdo
            startPlayVdo
            stopPlayVdo
          }
          unitSeq
          totalVdoLength
          totalLearnTime
          learnPercent
        }
        enrollNo
        courseOutlineRegistration {
          id
          academicPeriod {
            id
          }
          courseOutline {
            id
            instruction
            courseOutlineUnits {
              id
              seq
              nameLocal
              descriptionLocal
              preTestExpectScore
              postTestExpectScore
              unitAgenda
              unitObjective
              unitReference
            }
            courseOutlineAssessments {
              id
              assessment {
                nameLocal
              }
              seq
              percent
              score

            }
            vdoSets {
              id
              vdoSetUnits {
                id
                totalVdoLength
                unitSeq
                vdoSetTopics {
                  id
                }
              }
            }
          }
        }
        classSection {
          id
          courseOutlineRegistration {
            id
            courseOutline { id }
          }
          sectionNo
          learnSpanNo
          vdoSet {
            id
            totalVdoLength

            vdoSetUnits {
              id
              unitSeq
              nameLocal
              nameEng
              totalVdoLength
              status
              remark

              vdoSetTopics {
                id
                no
                nameLocal
                nameEng
                vdoLength
                vdoStreamPath
                remark
              }
            }
          }
          classAssignments {
            id
            sectionNo
            topicLocal
            topicEng
            descriptionLocal
            descriptionEng
            score
            dueDate
            uploadPath
            uploadPathUri
            uploadFileName
          }
          classMaterials {
            id
            sectionNo
            nameLocal
            nameEng
            uploadPath
            uploadPathUri
            uploadFileName
          }
        }
        sectionNo
        subject {
          id
          code
          nameLocal
          description
        }
        subjectCode
        teacher {
          id
          prefix {
            nameLocal
          }
          firstNameLocal
          lastNameLocal
          telephone
          email
          availableTime
          code
          picturePath
        }
        teacherCode
        credit
        learnSpanNo
        examSpanNo
        isDrop
        exams {
          id
          QuestionQty
          QuestionMultiQty
          QuestionTrueFalseQty
        }
      }
    }
  }
`;

export const GET_STUDENT_ENROLLDETAILS = gql`
  query getStudentEnrollDetailsByStudentEnrollId($id : ID!){
    getStudentEnrollDetailsByStudentEnrollId (
      id: $id
    ) {
      id
      studentEnroll {
        id
      }
      enrollNo
      courseOutlineRegistration {
        id
        courseOutline {
          id
          instruction
          courseOutlineUnits {
            id
            seq
            nameLocal
            descriptionLocal
            preTestExpectScore
            postTestExpectScore
            unitAgenda
            unitObjective
            unitReference
          }
          courseOutlineAssessments {
            id
            assessment {
              nameLocal
            }
            seq
            percent
            score

          }
          vdoSets {
            id
            vdoSetUnits {
              id
              totalVdoLength
              vdoSetTopics {
                id
              }
            }
          }
        }
      }
      classSection {
        id
        sectionNo
        learnSpanNo
        courseOutlineRegistration {
          id
          courseOutline { id }
        }
        classAssignments {
          id
          sectionNo
          topicLocal
          topicEng
          descriptionLocal
          descriptionEng
          score
          dueDate
          uploadPath
          uploadPathUri
          uploadFileName
        }
        classMaterials {
          id
          sectionNo
          nameLocal
          nameEng
          uploadPath
          uploadPathUri
          uploadFileName
        }
      }
      sectionNo
      subject {
        id
        code
        nameLocal
        description
      }
      subjectCode
      teacher {
        id
        prefix {
          nameLocal
        }
        firstNameLocal
        lastNameLocal
        telephone
        email
        availableTime
        code
      }
      teacherCode
      credit
      learnSpanNo
      examSpanNo
      isDrop
      exams {
        id
        QuestionQty
        QuestionMultiQty
        QuestionTrueFalseQty
      }
    }
  }
`;

export const GET_STUDENT_BY_CURRENT_USER = gql`
  query getStudentByCurrentUser{
    getStudentByCurrentUser{
      id
      code firstNameLocal lastNameLocal
      firstNameEng lastNameEng
      gender telephone email lineId
      picturePath birthDate citizenId
      studentConfirm
    }
  }
`;

export const UPDATE_STUDENT_INFORMATION = gql`
  mutation updateStudentInformation(
    $id: ID!,
    $studentInput: StudentInput!,
  ) {
    updateStudentInformation(
      id: $id
      studentInput: $studentInput
    ) {
      id
      degree{id code nameLocal nameEng}
      curriculum{id code nameLocal nameEng}
      faculty{id code nameLocal nameEng}
      department{id code nameLocal nameEng}
      code
      prefix{
        id nameLocal nameEng
      }
      firstNameLocal
      lastNameLocal
      firstNameEng
      lastNameEng
      gender
      telephone
      email
      birthDate
      citizenId
      lineId
      studentConfirm
      project{id nameLocal nameEng}
      studentStatus{id nameLocal nameEng}
      examLocation
      user{id userLogin }
    }
  }
`;

